import { connectMediaStore } from './withOwnReduxStore';
import { getCurrentGallectionSubfolders } from '../selectors';
var mapStateToProps = function (state) { return ({
    subfolders: getCurrentGallectionSubfolders(state),
}); };
export default connectMediaStore(mapStateToProps);
//# sourceMappingURL=withCurrentGallectionSubfolders.js.map